<template>
  <div class="headNav">
    <div class="head">
      <div class="mainContent">
        <img
          @click="getActive('Inicio')"
          class="logo"
          src="@/assets/image/logo.png"
          alt=""
        />
        <!-- 移动端汉堡按钮 -->
        <button
          type="button"
          class="hamburger"
          :class="{ open: menuOpen }"
          aria-label="Menú"
          @click="toggleMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <!-- PC 端导航 -->
        <ul class="nav nav-pc">
          <li :class="activeNav == 'Inicio' ? 'active' : ''">
            <a @click="getActive('Inicio')">Inicio</a>
          </li>
          <li :class="activeNav == 'sobre' ? 'active' : ''">
            <a @click="getActive('sobre')">Sobre nosotros</a>
          </li>
          <li :class="activeNav == 'Aviso' ? 'active' : ''">
            <a @click="getActive('Aviso')">Aviso de privacidad</a>
          </li>
          <li :class="activeNav == 'ayuda' ? 'active' : ''">
            <a @click="getActive('ayuda')">Ayuda</a>
          </li>
          <li :class="activeNav == 'loan' ? 'active' : ''">
            <a @click="getActive('loan')">Términos y condiciones</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 移动端下拉导航遮罩 -->
    <div v-show="menuOpen" class="nav-overlay" @click="closeMenu"></div>
    <!-- 移动端下拉导航 -->
    <div class="nav-dropdown" :class="{ open: menuOpen }">
      <ul class="nav nav-mobile">
        <li :class="activeNav == 'Inicio' ? 'active' : ''">
          <a @click="navClick('Inicio')">Inicio</a>
        </li>
        <li :class="activeNav == 'sobre' ? 'active' : ''">
          <a @click="navClick('sobre')">Sobre nosotros</a>
        </li>
        <li :class="activeNav == 'Aviso' ? 'active' : ''">
          <a @click="navClick('Aviso')">Aviso de privacidad</a>
        </li>
        <li :class="activeNav == 'ayuda' ? 'active' : ''">
          <a @click="navClick('ayuda')">Ayuda</a>
        </li>
        <li :class="activeNav == 'loan' ? 'active' : ''">
          <a @click="navClick('loan')">Términos y condiciones</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import "./scss/nav.scss";

export default {
  name: "headNav",
  props: ["activeNav"],
  data() {
    return {
      active_blog: 0,
      menuOpen: false,
      list: [
        "Transparencia",
        "Derechos y obligaciones de cobranza",
        "Aviso importante",
      ],
    };
  },
  created() {
    if (sessionStorage.getItem("tip")) {
      this.list.forEach((item, index) => {
        if (index == sessionStorage.getItem("tip")) {
          this.active_blog = sessionStorage.getItem("tip");
        }
      });
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    navClick(val) {
      this.getActive(val);
      this.closeMenu();
    },
    getActive(val, index) {
      let url = "";
      switch (val) {
        case "Inicio":
          url = "/home?dialogVisible=1";
          break;
        case "sobre":
          url = "/about";
          break;
        case "Aviso":
          url = "/notice";
          break;
        case "ayuda":
          url = "/help";
          break;
        case "privacidad":
          url = "/privacidad";
          break;
        case "loan":
          url = "/loan";
          break;
        case "transparenciaOne":
          url = "/transparenciaOne";
          break;
        case "transparenciaTwo":
          url = "/transparenciaTwo";
          break;
        case "transparenciaThree":
          url = "/transparenciaThree";
          break;
      }
      this.$router.push(url);
      sessionStorage.setItem("tip", index);
    },
    handleCommand(command) {
      if (command == 0) {
        this.getActive("transparenciaOne", command);
      } else if (command == 1) {
        this.getActive("transparenciaTwo", command);
      } else {
        this.getActive("transparenciaThree", command);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.li_blog {
  display: flex;
  align-items: center;
  .el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 12px;
      height: 8px;
      margin-left: 10px;
    }
  }
}
.el-dropdown-menu {
  padding: 0;
  li {
    width: 320px;
    background: #fff;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    padding: 20px 0;
    box-sizing: border-box;
    &:first-child {
      border-bottom: 1px solid #edecec;
    }
    &:hover {
      color: #4E68F3;
    }
  }
  .active_color {
    color: #4E68F3;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
}
</style>
